module.exports = __webpack_public_path__ + "media/images/map/8-25c8ff801c45dfb1604c9b4d40e0d3ee.png";